import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { IProductsStatusHistory, IStatusHistory } from '../../../types/schedule'
import { ProductStatus } from '../../../entity/Product'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductSchedulesHistory = createAsyncThunk<
    { guid: string; data: IProductsStatusHistory } | void,
    { productId: string; status: Uncapitalize<ProductStatus>; before?: string },
    ThunkConfig<string>
>('schedulesSlice/fetchProductSchedulesHistory', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { productId, status, before } = args

    try {
        const { data } = await api.get<{
            has_more: boolean
            status_history: Array<IStatusHistory>
        }>(getUrlWithVersion(`/products/${productId}/status/history`), {
            params: {
                status,
                before: before || null,
                limit: 300,
            },
        })

        if (!Array.isArray(data?.status_history)) {
            const error = new Error('Received status history in wrong format')
            console.error(error.message)
            return
        }

        return {
            guid: productId,
            data: {
                hasMore: data.has_more,
                historyRecords: data.status_history,
            },
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch product schedules history')
    }
})
